import React, { Component } from 'react';
import { addBonusDialogueStyles } from '../../styles';

import { MyPATTextField } from "../../../common/index";
import {
    WithStyles,
    Modal,
    Card,
    CardHeader,
    IconButton,
    Typography,
    CardContent,
    Grid,
    withStyles,
    Button,
} from "@material-ui/core";
import {
  CloseOutlined as CloseIcon
} from '@material-ui/icons';

interface AddBonusDialogProps extends WithStyles<typeof addBonusDialogueStyles>  {
  isDialogOpen: boolean;
  handleOnClick?: Function;
  handlePopUpClose?: Function
}
 
interface AddBonusDialogState {
    textValue: string;
    errorMessage: any
}
 
class AddBonusDialog extends Component<AddBonusDialogProps, AddBonusDialogState> {
    constructor(props: AddBonusDialogProps) {
        super(props);
        this.state = { 
          textValue: '',
          errorMessage: ''
        };
    }
  
    handleTextValidation = (value: any) => {
      let convertedValue = Number(value);
      if(isNaN(convertedValue)){
       this.setState({
         errorMessage: 'Please enter a Number'
       })
      }else{
         this.setState({
           errorMessage: ''
         })
      }
    }

    handleOnChange = (event: any) => {
      const { value } = event.target;
      // console.log(':VALUE:::::::',value, typeof value, typeof +value)
      if(+value <=100) {
        const text = event.target.value;
        this.handleTextValidation(text)
        this.setState({
          textValue: text
        });
      }
    }
    render() { 
    const { isDialogOpen, classes, handleOnClick, handlePopUpClose  } = this.props;
        return (  
            <Modal
        className={[
          classes.fontSizeLG,
          classes.fontWeight500,
          classes.modal,
        ].join(" ")}
        open={isDialogOpen}
      >
        <div >
          <Card >
            <CardHeader
              className={classes.modalHeader}
              action={
                <IconButton
                  aria-label="settings"
                  onClick={() => handlePopUpClose && handlePopUpClose()}
                >
                  <CloseIcon className={classes.fontSizeLG} />
                </IconButton>
              }
              title={
                <Typography
                  align="center"
                  className={[classes.fontWeight500, classes.font16].join(
                    " "
                  )}
                >
                  Add Bonus Content
                </Typography>
              }
            />
            <CardContent>
              <Grid
                container
                spacing={8}
                alignItems="center"
              >
                <Grid
                  container
                  className={[classes.formControllContainer, classes.mb1x].join(
                    " "
                  )}
                >
                  <Grid item xs={8}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      className={classes.headingText}
                    >
                    Mention the following criteria : 
                    </Typography>
                    
                  </Grid>
                  <Grid
                    container
                    justify="space-between"
                    className={classes.mb1x}
                    alignItems="center"
                  >
                    <Grid item>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={[classes.inputLabel, classes.m0].join(' ')}
                      >
                      Proficiency
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Grid container justify="flex-start">
                        <Grid item className={classes.normalLabel}>
                          At least
                        </Grid>
                        <Grid className={classes.customFieldInput}>
                          <MyPATTextField
                            fullWidthControl={false}
                            inputId="Value"
                            name="Value"
                            value={this.state.textValue}
                            placeholder="Value (%)"
                            onChange={this.handleOnChange}
                            error = {this.state.errorMessage}
                            errorText={this.state.errorMessage}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>              
            </CardContent>
            < Grid item className={classes.modalfooter} container justify="flex-end" alignItems="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={(this.state.errorMessage !== ''|| this.state.textValue === '')}
                  onClick={()=> handleOnClick && handleOnClick(this.state.textValue) }
                >
                  Save
                </Button>
              </Grid>
          </Card>
        </div>
       </Modal>
        );
    }
}

// @ts-ignore
export default withStyles(addBonusDialogueStyles)(AddBonusDialog);